import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
    no: {
        // Header
        collection: 'Produkter',
        ourStory: 'Om oss',
        signIn: 'Logg Inn',
        signOut: 'Logg Ut',
        myOrders: 'Mine Ordre',
        signedInAs: 'Logget inn som',
        
        // Hero
        heroSubtitle: 'Norges Første Mineralvann-Kurator',
        heroTitle: 'Water is just the carrier',
        heroDescription: 'Mineralene er det som betyr noe. Vi importerer vann fra naturlige kilder med eksepsjonelt høyt nivå av mineraler — nøye utvalgt for deres unike smak og funksjonelle egenskaper.',
        exploreCollection: 'Utforsk Porteføljen',
        
        // Philosophy Section
        ourPhilosophy: 'Vår Filosofi',
        philosophyTitle: 'Vann er mer enn hydrering',
        philosophyText1: 'Cellene dine er som små batterier – og mineraler er strømmen. Når du drikker vann med naturlige mineraler som kalsium, magnesium og kalium, er disse allerede i ionisk form. Det betyr at kroppen kan ta dem direkte opp, uten å måtte bryte dem ned først.',
        philosophyText2: 'Vann uten mineraler er som en tom bærer – det går gjennom kroppen uten å levere det cellene faktisk trenger.',
        philosophyText3: 'Derfor skapte vi Raw Minerals – for å løfte en undervurdert kategori - og gjøre mineralvann til en opplevelse igjen.',
        philosophyText4: '',
        
        // Training Section
        trainingTitle: 'Trening & Restitusjon',
        trainingHeading: 'Funksjonell hydrering',
        trainingText1: 'Når du trener, taper kroppen mer enn bare væske. Du mister elektrolytter og mineraler som er essensielle for muskelkontraksjon, nervefunksjon og energiomsetning.',
        trainingText2: 'Vanlig vann erstatter væsken - men ikke nødvendigvis mineralene og elektrolyttene. Naturlig mineralvann med høyt innhold av magnesium, kalsium og natrium gir kroppen det den faktisk trenger for optimal restitusjon.',
        trainingText3: 'Naturlige mineralvann fra beskyttede kilder kan inneholde opptil 1000 mg magnesium per liter, betydelige mengder kalsium og naturlig bikarbonat. Dette er ikke tilsatt - det er naturens egen formel.',
        trainingText4: 'Funksjonell hydrering handler om å velge vann som jobber for kroppen din - ikke bare gjennom den.',
        
        // Restaurant & Gastronomy Section
        gastronomyTitle: 'Restaurant & Gastronomi',
        gastronomyHeading: 'Vannets rolle på bordet',
        gastronomyText1: 'Akkurat som vin har mineralvann sin egen karakter – fra lett og friskt til mineralrikt og komplekst. Riktig vann kan løfte en matopplevelse, rense ganen mellom retter og skape balanse i smaksbildet.',
        gastronomyText2: 'Til fete og kraftige retter passer mineralrikt vann med høy karbonering – det kutter gjennom og forbereder ganen på neste bit. Til delikate smaker som skalldyr og sushi fungerer et stillere, mykere vann som ikke konkurrerer med smakene.',
        gastronomyText3: 'Også til vin spiller vannet en viktig rolle. Et vann med riktig mineralbalanse fremhever vinens karakter – friskhet, frukt eller mineralitet – mens feil vann kan overdøve eller skape disharmoni. Vannet du serverer bør sees på som en del av en helhetlig vinopplevelse.',
        gastronomyText4: 'For restauranter og hoteller representerer premium mineralvann en mulighet til å tilby et alkoholfritt alternativ med like mye historie og identitet som vinen.',
        gastronomyText5: 'Vi ser på valg av drikke som en viktig del av et gjennomtenkt måltid. Enten man foretrekker vin eller mineralvann, kan riktig drikke fremheve råvarene, balansere smakene og bidra til en bedre matopplevelse.',
        
        // Health & Wellness Section
        wellnessTitle: 'Helse & Velvære',
        wellnessHeading: 'Mineraler i balanse',
        wellnessText1: 'Kroppen din er avhengig av mineraler for hundrevis av funksjoner – fra nervesignaler og muskelkontraksjoner til beinbygning og søvnkvalitet. Mange får ikke i seg nok gjennom kosten alene.',
        wellnessText2: 'Naturlig mineralvann gir mineraler i ionisk form – den formen kroppen lettest tar opp. Magnesium for avslapning og søvn, kalsium for bein og muskler, bikarbonat for fordøyelse og syre-base-balanse.',
        wellnessText3: 'I motsetning til kosttilskudd, kommer mineralene i vann i naturlige proporsjoner og kombinasjoner, slik de har blitt dannet gjennom geologiske prosesser over tusenvis av år.',
        wellnessText4: 'Å velge riktig mineralvann kan være et enkelt og naturlig grep for bedre velvære i hverdagen.',

        // Mineral Calculator Section
        calculatorTitle: 'Mineralkalkulator',
        calculatorHeading: 'Finn ditt mineralbehov',
        calculatorDescription: 'Beregn hvor mye mineralvann du trenger basert på din kropp og livsstil. Basert på WHO/FAO anbefalinger.',
        age: 'Alder',
        gender: 'Kjønn',
        male: 'Mann',
        female: 'Kvinne',
        weight: 'Vekt (kg)',
        activityLevel: 'Aktivitetsnivå',
        sedentary: 'Stillesittende',
        moderate: 'Moderat aktiv',
        active: 'Aktiv',
        veryActive: 'Svært aktiv',
        calculate: 'Beregn',
        yourWeeklyNeeds: 'Ditt ukentlige behov',
        magnesiumNeed: 'Magnesium',
        calciumNeed: 'Kalsium',
        sodiumNeed: 'Natrium',
        potassiumNeed: 'Kalium',
        bicarbonateBenefit: 'Bikarbonat',
        perWeek: 'per uke',
        recommendedCombination: 'Din ukentlige mineralvannpakke',
        bottlesPerWeek: 'flasker/uke',
        coversYourNeed: 'dekker ditt behov for',
        mgPerDay: 'mg/dag',
        basedOnProfile: 'Ditt estimerte daglige behov',
        basedOnProfileSubtitle: 'Basert på din profil og WHO/FAO anbefalinger',
        totalCoverage: 'Total mineraldekning',
        weeklyPlan: 'Ukentlig drikkeplan',
        source: 'Kilde: WHO/FAO anbefalinger',
        lowSodium: 'Redusert saltinntak',
        lowSodiumDescription: 'Tilpass for lavere natriuminnhold',
        
        // Health focus options
        healthFocus: 'Fokusområder',
        healthFocusDescription: 'Velg hva du ønsker å fokusere på',
        focusSleep: 'Søvn',
        focusStress: 'Stressmestring',
        focusRecovery: 'Restitusjon',
        focusEndurance: 'Utholdenhet',
        focusMuscle: 'Muskelplager',
        focusInjury: 'Skadeforebygging',
        focusEnergy: 'Energi',
        focusDigestion: 'Fordøyelse',
        focusConcentration: 'Konsentrasjon',
        focusBoneHealth: 'Benhelse',
        
        // Values Section
        whatWeBelieve: 'Hva Vi Tror På',
        knowledgeIsTaste: 'Kunnskap er smak',
        originMatters: 'Opprinnelse Betyr Noe',
        originMattersDesc: 'Hver vannkilde har et unikt geologisk fingeravtrykk. Vi sporer hver dråpe til sin rene opprinnelse.',
        mineralIntelligence: 'Mineral-Intelligens',
        mineralIntelligenceDesc: 'Å forstå mineralinnhold forvandler hydrering til et bevisst valg for kroppen din.',
        uncompromisingQuality: 'Kompromissløs Kvalitet',
        uncompromisingQualityDesc: 'Vi samarbeider kun med kilder som møter de høyeste standarder for renhet og bærekraftig utvinning.',
        
        // Featured Section
        featuredSelection: 'Utvalgte Produkter',
        curatedForYou: 'Kuratert for deg',
        viewAll: 'Se Alle',
        
        // CTA Section
        beginYourJourney: 'Start Din Reise',
        discoverWater: 'Oppdag hva vann virkelig kan være',
        shopCollection: 'Handle Porteføljen',
        
        // Products Page
        ourCollection: 'Vår Portefølje',
        mineralWaters: 'Mineralvann',
        productsDescription: 'Hvert vann i vår portefølje er valgt for sin unike mineralsammensetning, eksepsjonelle renhet og fornemme opprinnelse.',
        filters: 'Filtre',
        type: 'Type',
        allTypes: 'Alle Typer',
        stillWater: 'Stille Vann',
        sparklingWater: 'Kullsyrevann',
        origin: 'Opprinnelse',
        allOrigins: 'Alle Opprinnelser',
        clearFilters: 'Fjern Filtre',
        showing: 'Viser',
        products: 'produkter',
        product: 'produkt',
        noProductsFound: 'Ingen produkter funnet',
        
        // Product Detail
        backToCollection: 'Tilbake til Porteføljen',
        addToCart: 'Legg i Handlekurv',
        adding: 'Legger til...',
        outOfStock: 'Utsolgt',
        productDetails: 'Produktdetaljer',
        bottleSize: 'Flaskestørrelse',
        phLevel: 'pH-Nivå',
        mineralAnalysis: 'Mineralanalyse',
        healthBenefits: 'Helsefordeler',
        
        // Cart
        shoppingCart: 'Handlekurv',
        signInToViewCart: 'Logg inn for å se handlekurven',
        pleaseSignIn: 'Vennligst logg inn for å få tilgang til handlekurven din',
        yourCartIsEmpty: 'Handlekurven din er tom',
        exploreCollectionDesc: 'Utforsk vår portefølje og finn ditt perfekte mineralvann',
        browseCollection: 'Bla i Porteføljen',
        orderSummary: 'Ordresammendrag',
        subtotal: 'Delsum',
        shipping: 'Frakt',
        free: 'Gratis',
        total: 'Totalt',
        proceedToCheckout: 'Gå til Kassen',
        continueShopping: 'Fortsett å Handle',
        removedFromCart: 'Fjernet fra handlekurv',
        addedToCart: 'Lagt til i handlekurv',
        
        // Checkout
        checkout: 'Kasse',
        reviewOrder: 'Se gjennom bestillingen din og fortsett til sikker betaling',
        orderReview: 'Ordregjennomgang',
        qty: 'Antall',
        secureCheckout: 'Sikker Betaling',
        secureCheckoutDesc: 'Betalingen din behandles sikkert gjennom Stripe',
        payWith: 'Betal med Stripe',
        processing: 'Behandler...',
        byProceeding: 'Ved å fortsette godtar du våre vilkår',
        
        // Checkout Success/Cancel
        processingPayment: 'Behandler Betaling',
        pleaseWait: 'Vennligst vent mens vi bekrefter betalingen din...',
        paymentSuccessful: 'Betaling Vellykket',
        thankYou: 'Takk for bestillingen! Du vil motta en bekreftelse på e-post snart.',
        viewOrders: 'Se Ordre',
        paymentStatusUnknown: 'Betalingsstatus Ukjent',
        couldNotConfirm: 'Vi kunne ikke bekrefte betalingsstatusen din. Vennligst sjekk ordrene dine eller kontakt support.',
        checkOrders: 'Sjekk Ordre',
        paymentCancelled: 'Betaling Avbrutt',
        paymentCancelledDesc: 'Betalingen din ble avbrutt. Varene i handlekurven er fortsatt lagret.',
        returnToCart: 'Tilbake til Handlekurv',
        
        // Auth
        welcomeBack: 'Velkommen Tilbake',
        signInToAccount: 'Logg inn på kontoen din',
        email: 'E-post',
        password: 'Passord',
        signingIn: 'Logger inn...',
        dontHaveAccount: 'Har du ikke en konto?',
        createOne: 'Opprett en',
        createAccount: 'Opprett Konto',
        joinCommunity: 'Bli med i vårt fellesskap',
        fullName: 'Fullt Navn',
        creatingAccount: 'Oppretter konto...',
        atLeast6Chars: 'Minst 6 tegn',
        alreadyHaveAccount: 'Har du allerede en konto?',
        
        // Account
        myAccount: 'Min Konto',
        accountDetails: 'Kontodetaljer',
        name: 'Navn',
        orderHistory: 'Ordrehistorikk',
        noOrdersYet: 'Ingen ordre ennå',
        items: 'varer',
        item: 'vare',
        confirmed: 'bekreftet',
        pending: 'venter',
        cancelled: 'avbrutt',
        paid: 'betalt',
        
        // About Page
        ourStoryTitle: 'Vann er mer enn hydrering',
        norwaysFirst: '',
        aboutIntro: `Hos Raw Minerals mener vi at vann er langt mer enn hydrering. Naturlig mineralvann er et resultat av en geologisk prosess som over tid beriker vannet med en unik mineralsammensetning – noe som gir hvert vann sin egen karakter, smak og identitet.

Vi etablerte Raw Minerals fordi vi opplever at forskjellen mellom vanlig drikkevann og naturlig mineralvann er en av de mest underkommuniserte historiene innen mat, drikke og helse. På samme måte som vin, kaffe og råvarer har opprinnelse og terroir, har også mineralvann en historie som fortjener å bli fortalt.

Bak Raw Minerals står vi, Morten og Tina. Morten har bakgrunn fra vin- og gastronomifaget, mens Tina kommer fra toppidretten og har en stor lidenskap for helse, ernæring og velvære. Felles for oss er nysgjerrigheten på kvalitet, kunnskap og gode opplevelser. Gjennom reiser til flere av verdens blå soner – områdene hvor mennesker lever og holder seg friske lengst – oppdaget vi hvilken naturlig plass mineralvann har i hverdagen. Ikke som en trend, men som en selvfølgelig del av måltidet, kulturen og livsstilen. Det fikk oss til å stille et enkelt spørsmål: Hvorfor er denne kunnskapen så lite kjent i Norge?

Vi er ikke bare en distributør – vi er en kurator. Vi håndplukker noen av Europas mest anerkjente mineralvann basert på kvalitet, dokumentert opprinnelse, mineralsammensetning, gastronomisk verdi og bærekraftig forvaltning av kildene.

For hoteller, restauranter og velværekonsepter utvikler vi hydreringsstrategier som løfter gjesteopplevelsen. Akkurat som en sommelier setter sammen en vinliste, hjelper vi våre partnere med å tilby mineralvann som passer ulike smaker, retter og anledninger.

Raw Minerals er bygget på kunnskap, nysgjerrighet og respekt for naturen. Vår ambisjon er enkel: å inspirere flere til å oppdage at vann kan være langt mer enn bare vann.`,
        bornFromNorwegian: 'Springvann, kildevann og mineralvann – hva er forskjellen?',
        aboutStory1: 'Springvann i Norge omtales ofte som mykt og rent og blant verdens beste. Men hva betyr egentlig dette? I realiteten beskriver dette vann som ofte er mineralfattig og ultraprosessert – behandlet med klor, UV-lys og filtrering for å fjerne alt, inkludert verdifulle mineraler.',
        aboutStory2: 'Kildevann kommer fra en naturlig kilde, men trenger ikke inneholde spesielle mineraler. Ekte mineralvann, derimot, har et dokumentert og stabilt mineralinnhold fra geologiske formasjoner – uberørt av industriell prosessering.',
        ourPhilosophyQuote: '"Å forstå vann er å forstå selve livet."',
        philosophyDesc: 'Mineralene er det som betyr noe. Derfor importerer vi vann fra naturlige kilder med eksepsjonelt høyt nivå av mineraler — nøye utvalgt for deres unike smak og funksjonelle egenskaper. I dag brukes mineralvann som en samlebetegnelse for alt alkoholfritt - fra brus, til jus og vann med kunstige smaker. Det ekte mineralvannet har mistet sin plass.',
        whatWeStandFor: 'Hva Vi Står For',
        valuesGuide: 'Verdiene som veileder oss',
        // Values Section
        valueSustainability: 'Bærekraft',
        valueSustainabilityDesc: 'Vi samarbeider med produsenter som forvalter sine naturlige kilder ansvarlig, og sikrer at fremtidige generasjoner også kan nyte disse unike ressursene.',
        valueSustainabilityDetail: `Hos Raw Minerals mener vi at ekte kvalitet og bærekraft går hånd i hånd. Naturlig mineralvann er en begrenset naturressurs som har brukt hundrevis – og i noen tilfeller tusenvis – av år på å dannes. Derfor samarbeider vi kun med produsenter som forvalter sine kilder med respekt, langsiktighet og dokumentert ansvarlighet.

Vi velger ikke produsenter utelukkende basert på vannets kvalitet. Like viktig er deres arbeid med vern av vannkilder, energieffektivisering, biologisk mangfold, ressursforvaltning og kontinuerlig forbedring av sin miljøpåvirkning. Vi søker langsiktige samarbeid med virksomheter som deler vårt syn på at naturressurser skal beskyttes – ikke bare utnyttes.

Vi er samtidig åpne om at naturlig mineralvann transporteres over landegrenser. Det er en avveining vi ikke forsøker å skjule. Ekte naturlig mineralvann er et opprinnelsesprodukt, på samme måte som vin, mat eller olivenolje fra bestemte regioner. Vannets unike mineralsammensetning er skapt av geologien og tiden det har brukt under bakken, og kan derfor ikke kopieres eller flyttes til et annet sted.

For oss handler bærekraft derfor om mer enn transport alene. Vi vurderer hele verdikjeden – hvordan kilden beskyttes, hvordan vannet tappes, hvilken emballasje som brukes, og hvordan produsenten arbeider for å redusere sitt klima- og miljøavtrykk over tid.

Alle mineralvannene i vår portefølje leveres på glassflasker. Glass er et naturlig materiale som kan gjenvinnes igjen og igjen uten tap av kvalitet, samtidig som det beskytter vannets opprinnelige smak og sammensetning. Som medlem av Grønt Punkt Norge tar vi ansvar for emballasjen vi setter på markedet og bidrar til at den samles inn, sorteres og gjenvinnes på en ansvarlig måte.

Våre produsenter arbeider aktivt med bærekraft på ulike områder. Gerolsteiner investerer i vern av vannkilder, biologisk mangfold, fornybar energi og reduksjon av klimagassutslipp. Vichy Catalan har et tydelig fokus på sirkulær økonomi, effektiv ressursbruk og økt bruk av resirkulerte materialer. ROI i Slovenia legger stor vekt på skånsom tapping og langsiktig bevaring av naturressursene rundt kilden, mens Marzia i Italia har valgt glass som sin foretrukne emballasje og arbeider aktivt for å redusere plastbruk.

Vi tror ikke bærekraft handler om å være perfekt. Vi tror det handler om å ta bevisste valg, være åpne om avveiningene og kontinuerlig arbeide for å bli bedre. Vår ambisjon er å gjøre det enklere for hoteller, restauranter og bevisste forbrukere å velge naturlig mineralvann som kombinerer dokumentert kvalitet med ansvarlig ressursforvaltning.

Raw Minerals – Europas fineste mineralvann, valgt med respekt for naturen.`,
        valueNatural: 'Naturlig',
        valueNaturalDesc: 'Ekte mineralvann er ubehandlet og uforandret. Det tappes direkte fra kilden, akkurat slik naturen skapte det.',
        valueNaturalDetail: `Geologi. Tid. Natur.
Naturlig mineralvann er ikke bare vann. Det er et av naturens mest unike produkter – formet av geologi, tid og en reise som kan vare i hundrevis, noen ganger tusenvis, av år.

Alt begynner som regn eller snø. Når vannet sakte trenger ned gjennom jordlag og bergarter, filtreres det naturlig samtidig som det tar opp mineraler fra omgivelsene. Hvilke mineraler vannet får med seg, bestemmes av geologien det passerer gjennom. Kalkstein tilfører kalsium, dolomitt bidrar med magnesium, mens andre bergarter setter sitt eget preg på vannets sammensetning.

Det er derfor ingen kilder er like. Hver eneste kilde utvikler sin egen mineralsignatur – et naturlig fingeravtrykk skapt av naturen selv. Akkurat som vin får sitt særpreg fra terroir, formes mineralvann av berggrunnen det har beveget seg gjennom.

Tid er den viktigste ingrediensen. Jo lenger vannet oppholder seg under bakken, desto mer utvikles balansen mellom mineralene. Når det til slutt når overflaten gjennom en beskyttet kilde, er sammensetningen resultatet av en geologisk prosess som ikke kan fremskyndes eller kopieres.
Derfor kan ekte naturlig mineralvann heller ikke produseres i en fabrikk. Det må komme fra en beskyttet underjordisk kilde, ha en naturlig stabil mineralsammensetning og tappes direkte ved kilden uten behandling som endrer vannets karakter.

Hos Raw Minerals ser vi ikke mineralvann som en tørsteslukker. Vi ser det som et autentisk naturprodukt – skapt av geologi, foredlet av tid og bevart av naturen.

Naturen gjorde filtreringen. Vi gjør utvelgelsen.`,
        valueKnowledge: 'Kunnskap',
        valueKnowledgeDesc: 'Vi tror på å dele innsikt om mineraler, kilder og vannets rolle i kroppen. Kunnskap gir bedre valg.',
        valueKnowledgeDetail: `Kunnskap. Lidenskap. Kuratering.

For oss er naturlig mineralvann langt mer enn en drikkevare. Det er et av naturens mest unike produkter – formet av geologi, tid og opprinnelse. Det fortjener å bli forstått, ikke bare servert.

Derfor er Raw Minerals mer enn en importør. Vi er en kurator og kunnskapspartner som håndplukker noen av Europas mest bemerkelsesverdige mineralvann. Hver kilde er valgt fordi den har en unik historie, en dokumentert mineralsammensetning og en kvalitet som skiller seg ut.

Vi ønsker å utfordre måten verden tenker om vann på. Akkurat som vin, kaffe og gastronomi har utviklet seg gjennom økt kunnskap, mener vi at naturlig mineralvann fortjener den samme nysgjerrigheten. Når mennesker forstår forskjellen, endrer også opplevelsen seg.

For våre samarbeidspartnere betyr dette mer enn tilgang til eksklusive produkter. Vi bidrar med innsikt, opplæring og konsepter som skaper merverdi – enten du driver restaurant, hotell, spa, treningssenter eller arbeider med helse og velvære.

Sammen utvikler vi en hydreringsfilosofi som styrker opplevelsen, skiller deg fra konkurrentene og gir gjestene og kundene en ny forståelse av hva vann faktisk kan være.

Vi er nysgjerrige, ambisiøse og kompromissløse i jakten på kvalitet. Vi følger utviklingen internasjonalt, besøker kildene, utfordrer etablerte sannheter og leter kontinuerlig etter produkter og kunnskap som kan flytte kategorien videre.

Det ekte mineralvannet har mistet sin plass.
Raw Minerals tar det tilbake.`,
        clickToReadMore: 'Klikk for å lese mer',
        clickToClose: 'Klikk for å lukke',
        basedInOslo: 'Basert i Oslo',
        fromNorway: 'Fra Norge til verden',
        osloDesc: 'Vårt hovedkontor i Oslo fungerer som sentrum for vår globale kurasjon. Herfra henter, tester og distribuerer vi verdens fineste mineralvann til kresne kunder over hele Skandinavia og utover.',
        
        // FAQ Section
        faqCaption: 'Spørsmål & Svar',
        faqTitle: 'Ofte stilte spørsmål',
        faqItems: [
            {
                q: 'Hva er forskjellen på mineralvann og vanlig springvann?',
                a: 'Springvann er ofte filtrert og renset, noe som fjerner både forurensninger og naturlige mineraler. Naturlig mineralvann kommer fra beskyttede underjordiske kilder og inneholder mineraler kroppen trenger – som magnesium, kalsium og bikarbonat – i en form som er lett for kroppen å ta opp.'
            },
            {
                q: 'Hvorfor er mineraler i vann bedre enn kosttilskudd?',
                a: 'Mineraler i naturlig mineralvann er allerede i ionisk form, noe som betyr at kroppen kan absorbere dem direkte uten å måtte bryte dem ned først. Kosttilskudd må ofte gjennom fordøyelsen før de kan tas opp, og absorpsjonsraten kan variere betydelig.'
            },
            {
                q: 'Kan mineralvann hjelpe med restitusjon etter trening?',
                a: 'Absolutt. Under trening taper du elektrolytter gjennom svette – spesielt natrium, magnesium og kalium. Mineralvann med høyt mineralinnhold kan erstatte disse naturlig, uten kunstige tilsetningsstoffer eller sukker som finnes i mange sportsdrikker.'
            },
            {
                q: 'Hva er elektrolytter, og hvorfor trenger kroppen dem?',
                a: 'Elektrolytter er mineraler med elektrisk ladning som regulerer væskebalanse, nervesignaler og muskelkontraksjoner. De viktigste er natrium, kalium, magnesium og kalsium. Ubalanse kan føre til kramper, utmattelse og nedsatt prestasjon.'
            },
            {
                q: 'Hvorfor serverer fine restauranter mineralvann?',
                a: 'Mineralvann har distinkte smaksprofiler som kan komplementere mat og vin. Vann med høy mineralitet kan fremheve smaken i rike retter, mens lettere vann passer til delikate smaker. Det handler om den totale matopplevelsen.'
            },
            {
                q: 'Er det sant at mineralvann kan påvirke smaken av kaffe og te?',
                a: 'Ja. Vannets mineralsammensetning påvirker ekstraksjon og smak. Vann med moderat mineralinnhold og nøytral pH gir ofte best resultat. For høyt kalsiuminnhold kan gi bitter smak, mens for lavt mineralinnhold gir flat smak.'
            },
            {
                q: 'Hvor mye mineralvann bør jeg drikke daglig?',
                a: 'Det anbefales generelt 1,5-2 liter væske daglig, men behovet varierer med aktivitetsnivå, klima og individuelle faktorer. Ved intens trening eller varme kan behovet dobles. Mineralvann kan dekke hele eller deler av væskebehovet.'
            },
            {
                q: 'Kan gravide og barn drikke mineralvann?',
                a: 'Ja, naturlig mineralvann er trygt for de fleste. Gravide kan faktisk ha nytte av ekstra kalsium og magnesium. For spedbarn under 6 måneder anbefales det å sjekke natriuminnholdet. Vann med lavt natriuminnhold er generelt trygt.'
            },
            {
                q: 'Hva betyr TDS (Total Dissolved Solids)?',
                a: 'TDS måler den totale mengden oppløste mineraler i vannet, uttrykt i mg/L. Lavt TDS (under 250) gir lett, nøytral smak. Middels TDS (250-800) gir mer karakter. Høyt TDS (over 800) gir kraftig mineralsmak og høyere mineralinntak.'
            },
            {
                q: 'Hvorfor er naturlig mineralvann dyrere enn flaskevann?',
                a: 'Ekte mineralvann kommer fra spesifikke, beskyttede kilder som har brukt hundrevis til tusenvis av år på å utvikle sin unike mineralsammensetning. Strenge kvalitetskrav, bærekraftig utvinning og transport fra kildene bidrar til prisen. Du betaler for autentisitet og kvalitet.'
            },
            {
                q: 'Er det sant at Norge er i verdenstoppen i både konsum av melk og forekomst av benskjørhet?',
                a: 'Ja, dette er et paradoks som har fått mye oppmerksomhet. Norge har et av verdens høyeste forbruk av meieriprodukter, men ligger også høyt på statistikken for osteoporose. Flere faktorer spiller inn, men én teori peker på at vi får lite kalsium og magnesium fra drikkevannet vårt – mineraler som er essensielle for benhelse. I land med hardere, mer mineralrikt vann ser man ofte lavere forekomst av benskjørhet.'
            },
            {
                q: 'Hva er forskjellen på kunstig mineralvann og naturlig mineralvann?',
                a: 'Naturlig mineralvann kommer fra beskyttede underjordiske kilder og har fått sin mineralsammensetning gjennom geologiske prosesser over lang tid. Kunstig mineralvann er vanlig vann tilsatt mineraler i en fabrikk. Forskjellen ligger i kompleksiteten – naturlig mineralvann inneholder ofte et bredt spekter av sporstoffer og mineraler i naturlig balanse, noe som er vanskelig å gjenskape kunstig.'
            },
            {
                q: 'Mineralvann på tunge glassflasker kan ikke være bra for miljøet. Hvorfor ikke gå over til plast?',
                a: 'Glass er faktisk mer miljøvennlig enn det kan virke. Det kan resirkuleres uendelig mange ganger uten tap av kvalitet, i motsetning til plast som degraderes ved hver resirkulering. Glass avgir heller ingen mikroplast eller kjemikalier til vannet. De fleste premium mineralvannprodusenter bruker også retursystemer der flaskene vaskes og gjenbrukes opptil 50 ganger. Det tunge glasset beskytter også vannets kvalitet bedre enn plast, som kan påvirkes av lys og temperatur.'
            },
            {
                q: 'Hvorfor selges brus, juice og andre alkoholfrie alternativer ofte som "mineralvann" på restauranter?',
                a: 'Dette er dessverre en utbredt misforståelse i bransjen. Begrepet "mineralvann" har blitt utvandet til å bety alt fra kullsyrevann til brus. Ekte naturlig mineralvann har en juridisk beskyttet definisjon i EU: det må komme fra en anerkjent underjordisk kilde med dokumentert og stabil mineralsammensetning. Når restauranter bruker "mineralvann" om vanlig kullsyrevann eller andre drikker, bidrar de til forvirring. Vi jobber for å utdanne både serveringsbransjen og forbrukere om hva ekte mineralvann faktisk er.'
            },
            {
                q: 'Finnes det mineralvann fra Norge med høyt innhold av mineraler?',
                a: 'Nei, dessverre ikke. Norges berggrunn består hovedsakelig av harde, krystallinske bergarter som granitt og gneis, som avgir svært lite mineraler til grunnvannet. Derfor er norsk drikkevann generelt "mykt" og mineralfattig. Land med sedimentære bergarter, vulkansk aktivitet eller kalksteinsformasjoner – som Slovenia, Italia, Tyskland og Spania – har naturlige forutsetninger for mineralrikt vann. Dette er grunnen til at vi importerer premium mineralvann fra disse regionene.'
            },
            {
                q: 'Hvorfor skal jeg kjøpe mineralvann når jeg kan investere i en vannrenser og tilsette mineraler selv?',
                a: 'Det høres logisk ut, men det er en vesentlig forskjell. Naturlig mineralvann har fått sin mineralsammensetning gjennom tusenvis av år i kontakt med geologiske formasjoner. Dette gir en kompleks blanding av mineraler og sporstoffer i naturlig balanse og ionisk form som kroppen lett kan ta opp. Kunstig tilsatte mineraler – selv de beste – kan ikke gjenskape denne kompleksiteten. I tillegg kommer mineralene i tilskudd ofte i former som er vanskeligere for kroppen å absorbere. Det er forskjellen på et naturprodukt og en industriell etterligning.'
            }
        ],
        
        // Footer
        footerDescription: 'Norges første spesialiserte importør av premium mineralvann. Vi leter frem verdens fineste vann for bevisste norske ganer.',
        navigate: 'Naviger',
        cart: 'Handlekurv',
        brochure: 'Brosjyre',
        contact: 'Kontakt',
        allRightsReserved: 'Alle rettigheter reservert.',
        norwaysFirstCurator: 'Norges Første Mineralvann-Kurator',
        
        // Misc
        pleaseLoginToAdd: 'Vennligst logg inn for å legge varer i handlekurven',
        failedToAdd: 'Kunne ikke legge til i handlekurv',
        failedToUpdate: 'Kunne ikke oppdatere handlekurv',
        failedToRemove: 'Kunne ikke fjerne vare',
        invalidCredentials: 'Ugyldige påloggingsdetaljer',
        registrationFailed: 'Registrering mislyktes',
        accountCreated: 'Konto opprettet!',
        productNotFound: 'Produkt ikke funnet',
        failedToCreateCheckout: 'Kunne ikke opprette betalingsøkt',
        cartEmpty: 'Handlekurven er tom',
        
        // Minerals
        calcium: 'Kalsium',
        magnesium: 'Magnesium',
        sodium: 'Natrium',
        potassium: 'Kalium',
        bicarbonate: 'Bikarbonat',
        ph: 'pH',
        tds: 'TDS',
    },
    en: {
        // Header
        collection: 'Products',
        ourStory: 'About us',
        signIn: 'Sign In',
        signOut: 'Sign Out',
        myOrders: 'My Orders',
        signedInAs: 'Signed in as',
        
        // Hero
        heroSubtitle: "Norway's First Mineral Water Curator",
        heroTitle: 'Water is just the carrier',
        heroDescription: 'The minerals are what matter. We import water from natural sources with exceptionally high mineral levels — carefully selected for their unique taste and functional properties.',
        exploreCollection: 'Explore the Collection',
        
        // Philosophy Section
        ourPhilosophy: 'Our Philosophy',
        philosophyTitle: 'Water is more than hydration',
        philosophyText1: 'Your cells are like tiny batteries – and minerals are the current. When you drink water with natural minerals like calcium, magnesium, and potassium, these are already in ionic form. This means your body can absorb them directly, without having to break them down first.',
        philosophyText2: 'Water without minerals is like an empty carrier – it passes through your body without delivering what your cells actually need.',
        philosophyText3: 'That\'s why we created Raw Minerals – to elevate an undervalued category - and make mineral water an experience again.',
        philosophyText4: '',
        
        // Training Section
        trainingTitle: 'Training & Recovery',
        trainingHeading: 'Functional hydration',
        trainingText1: 'When you train, your body loses more than just fluid. You lose electrolytes and minerals essential for muscle contraction, nerve function, and energy metabolism.',
        trainingText2: 'Regular water replaces the fluid - but not the minerals. Natural mineral water with high levels of magnesium, calcium, and sodium gives your body what it actually needs for optimal recovery.',
        trainingText3: 'Natural mineral waters from protected sources can contain up to 1000 mg of magnesium per liter, significant amounts of calcium, and natural bicarbonate. This isn\'t added - it\'s nature\'s own formula.',
        trainingText4: 'Functional hydration is about choosing water that works for your body - not just through it.',
        
        // Restaurant & Gastronomy Section
        gastronomyTitle: 'Restaurant & Gastronomy',
        gastronomyHeading: 'The role of water at the table',
        gastronomyText1: 'Just like wine, mineral water has its own character – from light and fresh to mineral-rich and complex. The right water can elevate a dining experience, cleanse the palate between courses, and create balance in the flavor profile.',
        gastronomyText2: 'For rich, hearty dishes, mineral-rich water with high carbonation works perfectly – it cuts through and prepares the palate for the next bite. For delicate flavors like shellfish and sushi, a stiller, softer water works best without competing with the flavors.',
        gastronomyText3: 'Water also plays an important role with wine. A water with the right mineral balance enhances the wine\'s character – freshness, fruit, or minerality – while the wrong water can overpower or create disharmony. The water you serve should be seen as part of a complete wine experience.',
        gastronomyText4: 'For restaurants and hotels, premium mineral water represents an opportunity to offer a non-alcoholic alternative with as much history and identity as wine.',
        gastronomyText5: 'We see the choice of beverage as an important part of a thoughtful meal. Whether one prefers wine or mineral water, the right drink can enhance the ingredients, balance the flavors, and contribute to a better dining experience.',
        
        // Health & Wellness Section
        wellnessTitle: 'Health & Wellness',
        wellnessHeading: 'Minerals in balance',
        wellnessText1: 'Your body depends on minerals for hundreds of functions – from nerve signals and muscle contractions to bone building and sleep quality. Many people don\'t get enough through diet alone.',
        wellnessText2: 'Natural mineral water provides minerals in ionic form – the form your body absorbs most easily. Magnesium for relaxation and sleep, calcium for bones and muscles, bicarbonate for digestion and acid-base balance.',
        wellnessText3: 'Unlike supplements, the minerals in water come in natural proportions and combinations, formed through geological processes over thousands of years.',
        wellnessText4: 'Choosing the right mineral water can be a simple and natural step toward better everyday wellness.',

        // Mineral Calculator Section
        calculatorTitle: 'Mineral Calculator',
        calculatorHeading: 'Find your mineral needs',
        calculatorDescription: 'Calculate how much mineral water you need based on your body and lifestyle. Based on WHO/FAO recommendations.',
        age: 'Age',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        weight: 'Weight (kg)',
        activityLevel: 'Activity Level',
        sedentary: 'Sedentary',
        moderate: 'Moderately active',
        active: 'Active',
        veryActive: 'Very active',
        calculate: 'Calculate',
        yourWeeklyNeeds: 'Your weekly needs',
        magnesiumNeed: 'Magnesium',
        calciumNeed: 'Calcium',
        sodiumNeed: 'Sodium',
        potassiumNeed: 'Potassium',
        bicarbonateBenefit: 'Bicarbonate',
        perWeek: 'per week',
        recommendedCombination: 'Your weekly mineral water package',
        bottlesPerWeek: 'bottles/week',
        coversYourNeed: 'covers your need for',
        mgPerDay: 'mg/day',
        basedOnProfile: 'Your estimated daily needs',
        basedOnProfileSubtitle: 'Based on your profile and WHO/FAO recommendations',
        totalCoverage: 'Total mineral coverage',
        weeklyPlan: 'HYDRATION PLAN',
        source: 'Source: WHO/FAO recommendations',
        lowSodium: 'Reduced sodium intake',
        lowSodiumDescription: 'Adjust for lower sodium content',
        
        // Health focus options
        healthFocus: 'Focus Areas',
        healthFocusDescription: 'Select what you want to focus on',
        focusSleep: 'Sleep',
        focusStress: 'Stress management',
        focusRecovery: 'Recovery',
        focusEndurance: 'Endurance',
        focusMuscle: 'Muscle issues',
        focusInjury: 'Injury prevention',
        focusEnergy: 'Energy',
        focusDigestion: 'Digestion',
        focusConcentration: 'Concentration',
        focusBoneHealth: 'Bone health',
        
        // Values Section
        whatWeBelieve: 'What We Believe',
        knowledgeIsTaste: 'Knowledge is taste',
        originMatters: 'Origin Matters',
        originMattersDesc: 'Each water source has a unique geological fingerprint. We trace every drop to its pristine origin.',
        mineralIntelligence: 'Mineral Intelligence',
        mineralIntelligenceDesc: 'Understanding mineral content transforms hydration into a conscious choice for your body.',
        uncompromisingQuality: 'Uncompromising Quality',
        uncompromisingQualityDesc: 'We partner only with sources that meet the highest standards of purity and sustainable extraction.',
        
        // Featured Section
        featuredSelection: 'Featured Selection',
        curatedForYou: 'Curated for you',
        viewAll: 'View All',
        
        // CTA Section
        beginYourJourney: 'Begin Your Journey',
        discoverWater: 'Discover what water can truly be',
        shopCollection: 'Shop the Collection',
        
        // Products Page
        ourCollection: 'Our Collection',
        mineralWaters: 'Mineral Waters',
        productsDescription: 'Each water in our collection is selected for its unique mineral composition, exceptional purity, and distinguished origin.',
        filters: 'Filters',
        type: 'Type',
        allTypes: 'All Types',
        stillWater: 'Still Water',
        sparklingWater: 'Sparkling Water',
        origin: 'Origin',
        allOrigins: 'All Origins',
        clearFilters: 'Clear Filters',
        showing: 'Showing',
        products: 'products',
        product: 'product',
        noProductsFound: 'No products found',
        
        // Product Detail
        backToCollection: 'Back to Collection',
        addToCart: 'Add to Cart',
        adding: 'Adding...',
        outOfStock: 'Out of Stock',
        productDetails: 'Product Details',
        bottleSize: 'Bottle Size',
        phLevel: 'pH Level',
        mineralAnalysis: 'Mineral Analysis',
        healthBenefits: 'Health Benefits',
        
        // Cart
        shoppingCart: 'Shopping Cart',
        signInToViewCart: 'Sign in to view your cart',
        pleaseSignIn: 'Please sign in to access your shopping cart',
        yourCartIsEmpty: 'Your cart is empty',
        exploreCollectionDesc: 'Explore our collection and find your perfect mineral water',
        browseCollection: 'Browse Collection',
        orderSummary: 'Order Summary',
        subtotal: 'Subtotal',
        shipping: 'Shipping',
        free: 'Free',
        total: 'Total',
        proceedToCheckout: 'Proceed to Checkout',
        continueShopping: 'Continue Shopping',
        removedFromCart: 'Removed from cart',
        addedToCart: 'Added to cart',
        
        // Checkout
        checkout: 'Checkout',
        reviewOrder: 'Review your order and proceed to secure payment',
        orderReview: 'Order Review',
        qty: 'Qty',
        secureCheckout: 'Secure Checkout',
        secureCheckoutDesc: 'Your payment is processed securely through Stripe',
        payWith: 'Pay with Stripe',
        processing: 'Processing...',
        byProceeding: 'By proceeding, you agree to our terms of service',
        
        // Checkout Success/Cancel
        processingPayment: 'Processing Payment',
        pleaseWait: 'Please wait while we confirm your payment...',
        paymentSuccessful: 'Payment Successful',
        thankYou: 'Thank you for your order! You will receive a confirmation email shortly.',
        viewOrders: 'View Orders',
        paymentStatusUnknown: 'Payment Status Unknown',
        couldNotConfirm: "We couldn't confirm your payment status. Please check your orders or contact support.",
        checkOrders: 'Check Orders',
        paymentCancelled: 'Payment Cancelled',
        paymentCancelledDesc: 'Your payment was cancelled. Your cart items are still saved.',
        returnToCart: 'Return to Cart',
        
        // Auth
        welcomeBack: 'Welcome Back',
        signInToAccount: 'Sign in to your account',
        email: 'Email',
        password: 'Password',
        signingIn: 'Signing In...',
        dontHaveAccount: "Don't have an account?",
        createOne: 'Create one',
        createAccount: 'Create Account',
        joinCommunity: 'Join our community',
        fullName: 'Full Name',
        creatingAccount: 'Creating Account...',
        atLeast6Chars: 'At least 6 characters',
        alreadyHaveAccount: 'Already have an account?',
        
        // Account
        myAccount: 'My Account',
        accountDetails: 'Account Details',
        name: 'Name',
        orderHistory: 'Order History',
        noOrdersYet: 'No orders yet',
        items: 'items',
        item: 'item',
        confirmed: 'confirmed',
        pending: 'pending',
        cancelled: 'cancelled',
        paid: 'paid',
        
        // About Page
        ourStoryTitle: 'Water is more than hydration',
        norwaysFirst: '',
        aboutIntro: `At Raw Minerals, we believe water is far more than hydration. Natural mineral water is the result of a geological process that enriches water with a unique mineral composition over time – giving each water its own character, taste, and identity.

We founded Raw Minerals because we believe the difference between ordinary drinking water and natural mineral water is one of the most under-communicated stories in food, beverage, and health. Just like wine, coffee, and fine ingredients have origin and terroir, mineral water also has a story worth telling.

Behind Raw Minerals are we, Morten and Tina. Morten has a background in wine and gastronomy, while Tina comes from elite sports and has a great passion for health, nutrition, and wellness. What we share is a curiosity for quality, knowledge, and great experiences. Through travels to several of the world's Blue Zones – the areas where people live and stay healthy longest – we discovered the natural place mineral water has in everyday life. Not as a trend, but as a natural part of meals, culture, and lifestyle. It made us ask a simple question: Why is this knowledge so little known in Norway?

We are more than a distributor – we are a curator. We handpick some of Europe's most renowned mineral waters based on quality, documented origin, mineral composition, gastronomic value, and sustainable stewardship of the sources.

For hotels, restaurants, and wellness concepts, we develop hydration strategies that elevate the guest experience. Just as a sommelier composes a wine list, we help our partners offer mineral waters suited to different tastes, dishes, and occasions.

Raw Minerals is built on knowledge, curiosity, and respect for nature. Our ambition is simple: to inspire more people to discover that water can be far more than just water.`,
        bornFromNorwegian: 'Tap water, spring water, and mineral water – what\'s the difference?',
        aboutStory1: 'Norwegian tap water is often praised as some of the world\'s best. But what do the words "soft" and "pure" really mean? In reality, they describe water that is mineral-poor and ultra-processed – treated with chlorine, UV light, and filtration to remove everything, including valuable minerals.',
        aboutStory2: 'Spring water comes from a natural source but doesn\'t need to contain any special minerals. True mineral water, however, has documented and stable mineral content from geological formations – untouched by industrial processing.',
        aboutStory3: 'Norway ranks among the highest in milk consumption, yet also tops the charts for osteoporosis (bone fragility). Could there be a connection to our low intake of naturally mineral-rich water? While we drink "soft" water, we may be missing out on calcium, magnesium, and other essential minerals the body needs – minerals that natural mineral water has delivered for thousands of years.',
        ourPhilosophyQuote: '"To understand water is to understand life itself."',
        philosophyDesc: "Minerals are what matter. That's why we import water from natural sources with exceptionally high mineral levels — carefully selected for their unique taste and functional properties. Today, mineral water is used as a catch-all term for everything non-alcoholic - from soda, to juice and artificially flavored water. True mineral water has lost its place.",
        whatWeStandFor: 'What We Stand For',
        valuesGuide: 'The values that guide us',
        // Values Section
        valueSustainability: 'Sustainability',
        valueSustainabilityDesc: 'We partner with producers who manage their natural sources responsibly, ensuring future generations can also enjoy these unique resources.',
        valueSustainabilityDetail: `At Raw Minerals, we believe that true quality and sustainability go hand in hand. Natural mineral water is a limited natural resource that has taken hundreds – and in some cases thousands – of years to form. Therefore, we only partner with producers who manage their sources with respect, long-term thinking, and documented responsibility.

We don't choose producers based solely on water quality. Equally important is their work on protecting water sources, energy efficiency, biodiversity, resource management, and continuous improvement of their environmental impact. We seek long-term partnerships with businesses that share our view that natural resources should be protected – not just exploited.

At the same time, we are open about the fact that natural mineral water is transported across borders. This is a trade-off we don't try to hide. True natural mineral water is a product of origin, just like wine, food, or olive oil from specific regions. The water's unique mineral composition is created by geology and the time it has spent underground, and therefore cannot be copied or moved to another location.

For us, sustainability is therefore about more than transport alone. We evaluate the entire value chain – how the source is protected, how the water is bottled, what packaging is used, and how the producer works to reduce their climate and environmental footprint over time.

All mineral waters in our portfolio are delivered in glass bottles. Glass is a natural material that can be recycled again and again without loss of quality, while protecting the water's original taste and composition. As a member of Grønt Punkt Norge, we take responsibility for the packaging we put on the market and contribute to its collection, sorting, and responsible recycling.

Our producers actively work on sustainability in various areas. Gerolsteiner invests in protecting water sources, biodiversity, renewable energy, and reducing greenhouse gas emissions. Vichy Catalan has a clear focus on circular economy, efficient resource use, and increased use of recycled materials. ROI in Slovenia places great emphasis on gentle bottling and long-term preservation of natural resources around the source, while Marzia in Italy has chosen glass as their preferred packaging and actively works to reduce plastic use.

We don't believe sustainability is about being perfect. We believe it's about making conscious choices, being open about the trade-offs, and continuously working to improve. Our ambition is to make it easier for hotels, restaurants, and conscious consumers to choose natural mineral water that combines documented quality with responsible resource management.

Raw Minerals – Europe's finest mineral waters, chosen with respect for nature.`,
        valueNatural: 'Natural',
        valueNaturalDesc: 'Real mineral water is untreated and unchanged. It is bottled directly from the source, exactly as nature created it.',
        valueNaturalDetail: `Geology. Time. Nature.
Natural mineral water is not just water. It is one of nature's most unique products – shaped by geology, time, and a journey that can last hundreds, sometimes thousands, of years.

It all begins as rain or snow. As the water slowly penetrates through soil layers and rock formations, it is naturally filtered while absorbing minerals from its surroundings. Which minerals the water picks up is determined by the geology it passes through. Limestone adds calcium, dolomite contributes magnesium, while other rock types leave their own mark on the water's composition.

That's why no two sources are alike. Every single source develops its own mineral signature – a natural fingerprint created by nature itself. Just as wine gets its character from terroir, mineral water is shaped by the bedrock it has moved through.

Time is the most important ingredient. The longer the water remains underground, the more the balance between minerals develops. When it finally reaches the surface through a protected spring, the composition is the result of a geological process that cannot be accelerated or copied.
That's why true natural mineral water cannot be produced in a factory. It must come from a protected underground source, have a naturally stable mineral composition, and be bottled directly at the source without treatment that alters the water's character.

At Raw Minerals, we don't see mineral water as a thirst quencher. We see it as an authentic natural product – created by geology, refined by time, and preserved by nature.

Nature did the filtering. We do the selecting.`,
        valueKnowledge: 'Knowledge',
        valueKnowledgeDesc: 'We believe in sharing insight about minerals, sources and the role of water in the body. Knowledge enables better choices.',
        valueKnowledgeDetail: `Knowledge. Passion. Curation.

For us, natural mineral water is far more than a beverage. It is one of nature's most unique products – shaped by geology, time, and origin. It deserves to be understood, not just served.

That's why Raw Minerals is more than an importer. We are a curator and knowledge partner who handpicks some of Europe's most remarkable mineral waters. Each source is chosen because it has a unique story, a documented mineral composition, and a quality that stands out.

We want to challenge the way the world thinks about water. Just as wine, coffee, and gastronomy have evolved through increased knowledge, we believe natural mineral water deserves the same curiosity. When people understand the difference, the experience also changes.

For our partners, this means more than access to exclusive products. We contribute insight, training, and concepts that create added value – whether you run a restaurant, hotel, spa, fitness center, or work with health and wellness.

Together, we develop a hydration philosophy that enhances the experience, sets you apart from competitors, and gives guests and customers a new understanding of what water can truly be.

We are curious, ambitious, and uncompromising in our pursuit of quality. We follow international developments, visit the sources, challenge established truths, and continuously search for products and knowledge that can move the category forward.

True mineral water has lost its place.
Raw Minerals is taking it back.`,
        clickToReadMore: 'Click to read more',
        clickToClose: 'Click to close',
        basedInOslo: 'Based in Oslo',
        fromNorway: 'From Norway to the world',
        osloDesc: 'Our headquarters in Oslo serves as the hub for our global curation. From here, we source, test, and distribute the world\'s finest mineral waters to discerning customers across Scandinavia and beyond.',
        
        // FAQ Section
        faqCaption: 'Questions & Answers',
        faqTitle: 'Frequently Asked Questions',
        faqItems: [
            {
                q: 'What is the difference between mineral water and regular tap water?',
                a: 'Tap water is often filtered and purified, which removes both contaminants and natural minerals. Natural mineral water comes from protected underground sources and contains minerals the body needs – such as magnesium, calcium, and bicarbonate – in a form that is easy for the body to absorb.'
            },
            {
                q: 'Why are minerals in water better than supplements?',
                a: 'Minerals in natural mineral water are already in ionic form, meaning the body can absorb them directly without having to break them down first. Supplements often need to go through digestion before they can be absorbed, and absorption rates can vary significantly.'
            },
            {
                q: 'Can mineral water help with recovery after exercise?',
                a: 'Absolutely. During exercise, you lose electrolytes through sweat – especially sodium, magnesium, and potassium. Mineral water with high mineral content can replace these naturally, without artificial additives or sugar found in many sports drinks.'
            },
            {
                q: 'What are electrolytes, and why does the body need them?',
                a: 'Electrolytes are minerals with an electrical charge that regulate fluid balance, nerve signals, and muscle contractions. The most important ones are sodium, potassium, magnesium, and calcium. Imbalance can lead to cramps, fatigue, and reduced performance.'
            },
            {
                q: 'Why do fine restaurants serve mineral water?',
                a: 'Mineral water has distinct flavor profiles that can complement food and wine. Water with high minerality can enhance the taste of rich dishes, while lighter water suits delicate flavors. It\'s about the total dining experience.'
            },
            {
                q: 'Is it true that mineral water can affect the taste of coffee and tea?',
                a: 'Yes. The water\'s mineral composition affects extraction and taste. Water with moderate mineral content and neutral pH often gives the best results. Too high calcium content can give a bitter taste, while too low mineral content gives a flat taste.'
            },
            {
                q: 'How much mineral water should I drink daily?',
                a: 'It is generally recommended to drink 1.5-2 liters of fluid daily, but needs vary with activity level, climate, and individual factors. During intense exercise or heat, needs can double. Mineral water can cover all or part of your fluid needs.'
            },
            {
                q: 'Can pregnant women and children drink mineral water?',
                a: 'Yes, natural mineral water is safe for most people. Pregnant women may actually benefit from extra calcium and magnesium. For infants under 6 months, it is recommended to check the sodium content. Water with low sodium content is generally safe.'
            },
            {
                q: 'What does TDS (Total Dissolved Solids) mean?',
                a: 'TDS measures the total amount of dissolved minerals in water, expressed in mg/L. Low TDS (below 250) gives a light, neutral taste. Medium TDS (250-800) gives more character. High TDS (above 800) gives a strong mineral taste and higher mineral intake.'
            },
            {
                q: 'Why is natural mineral water more expensive than bottled water?',
                a: 'Genuine mineral water comes from specific, protected sources that have taken hundreds to thousands of years to develop their unique mineral composition. Strict quality requirements, sustainable extraction, and transportation from the sources contribute to the price. You pay for authenticity and quality.'
            },
            {
                q: 'Is it true that Norway ranks among the highest in both milk consumption and osteoporosis?',
                a: 'Yes, this is a paradox that has received much attention. Norway has one of the world\'s highest consumption of dairy products, but also ranks high in osteoporosis statistics. Several factors play a role, but one theory points to our low intake of calcium and magnesium from drinking water – minerals that are essential for bone health. In countries with harder, more mineral-rich water, osteoporosis rates are often lower.'
            },
            {
                q: 'What is the difference between artificial mineral water and natural mineral water?',
                a: 'Natural mineral water comes from protected underground sources and has acquired its mineral composition through geological processes over time. Artificial mineral water is regular water with added minerals in a factory. The difference lies in complexity – natural mineral water often contains a broad spectrum of trace elements and minerals in natural balance, which is difficult to replicate artificially.'
            },
            {
                q: 'Heavy glass bottles for mineral water can\'t be good for the environment. Why not switch to plastic?',
                a: 'Glass is actually more environmentally friendly than it may seem. It can be recycled infinitely without loss of quality, unlike plastic which degrades with each recycling. Glass also doesn\'t release microplastics or chemicals into the water. Most premium mineral water producers also use return systems where bottles are washed and reused up to 50 times. The heavy glass also protects the water\'s quality better than plastic, which can be affected by light and temperature.'
            },
            {
                q: 'Why are soft drinks, juice, and other non-alcoholic alternatives often sold as "mineral water" in restaurants?',
                a: 'This is unfortunately a widespread misconception in the industry. The term "mineral water" has been diluted to mean everything from sparkling water to soft drinks. True natural mineral water has a legally protected definition in the EU: it must come from a recognized underground source with documented and stable mineral composition. When restaurants use "mineral water" to describe regular sparkling water or other drinks, they contribute to confusion. We work to educate both the hospitality industry and consumers about what real mineral water actually is.'
            },
            {
                q: 'Is there mineral water from Norway with high mineral content?',
                a: 'No, unfortunately not. Norway\'s bedrock consists mainly of hard, crystalline rocks like granite and gneiss, which release very few minerals into groundwater. Therefore, Norwegian drinking water is generally "soft" and mineral-poor. Countries with sedimentary rocks, volcanic activity, or limestone formations – such as Slovenia, Italy, Germany, and Spain – have natural conditions for mineral-rich water. This is why we import premium mineral water from these regions.'
            },
            {
                q: 'Why should I buy mineral water when I can invest in a water purifier and add minerals myself?',
                a: 'It sounds logical, but there is a significant difference. Natural mineral water has acquired its mineral composition over thousands of years in contact with geological formations. This creates a complex blend of minerals and trace elements in natural balance and ionic form that the body can easily absorb. Artificially added minerals – even the best ones – cannot recreate this complexity. Additionally, minerals in supplements often come in forms that are harder for the body to absorb. It\'s the difference between a natural product and an industrial imitation.'
            }
        ],
        
        // Footer
        footerDescription: "Norway's first specialized importer of premium mineral waters. We curate the world's finest waters for the discerning palate.",
        navigate: 'Navigate',
        cart: 'Cart',
        brochure: 'Brochure',
        contact: 'Contact',
        allRightsReserved: 'All rights reserved.',
        norwaysFirstCurator: "Norway's First Mineral Water Curator",
        
        // Misc
        pleaseLoginToAdd: 'Please login to add items to cart',
        failedToAdd: 'Failed to add to cart',
        failedToUpdate: 'Failed to update cart',
        failedToRemove: 'Failed to remove item',
        invalidCredentials: 'Invalid credentials',
        registrationFailed: 'Registration failed',
        accountCreated: 'Account created successfully!',
        productNotFound: 'Product not found',
        failedToCreateCheckout: 'Failed to create checkout session',
        cartEmpty: 'Cart is empty',
        
        // Minerals
        calcium: 'Calcium',
        magnesium: 'Magnesium',
        sodium: 'Sodium',
        potassium: 'Potassium',
        bicarbonate: 'Bicarbonate',
        ph: 'pH',
        tds: 'TDS',
    }
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        const saved = localStorage.getItem('language');
        return saved || 'no';
    });

    useEffect(() => {
        localStorage.setItem('language', language);
    }, [language]);

    const t = (key) => {
        return translations[language][key] || translations['en'][key] || key;
    };

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'no' ? 'en' : 'no');
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};
